module.exports = __webpack_public_path__ + "static/media/default-credit-card.9015a96e.png";